/**
 * 功能模块默认入口路由
 *
 * 登录后单模块直进与功能选择页自动进入共用，保证两处行为一致。
 */
export function getFunctionEntryRoute(funcKey: string, roleName: string): string {
  switch (funcKey) {
    case 'admin':
      return '/admin/system';
    case 'exam':
      return roleName === '学生' ? '/exam/my-tasks' : '/exam/knowledge';
    case 'knowledge':
      return roleName === '学员' ? '/knowledge/chat' : '/knowledge/archives';
    case 'share':
      switch (roleName) {
        case '销售':
          return '/share/customers';
        case '研发':
        case '采购':
          return '/share/approvals';
        case '供应商':
          return '/share/manage';
        case '客户':
          return window.innerWidth <= 768 ? '/share/feed' : '/share/browse';
        default:
          return '/share/manage';
      }
    case 'work':
      return '/work/records';
    case 'drawing':
      return '/drawing/materials';
    default:
      return '/select-function';
  }
}
